import { List, Toast, Form } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import {
  COURSE_TYPE_SORT_ORDER,
  customSorting,
  jsonToQuery,
  momentDate,
  upperCase,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Button, Card, Col, Row } from "react-bootstrap";
import DayOrderDates from "./dayOrderDates";
import DayOrderByDates from "./dayOrderByDates";

const MarkedHostelAttendanceReport = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const dayOrderDatesRef = useRef();
  const [loader, setLoader] = useState(false);
  const [courseTypes, setCourseTypes] = useState([]);
  const [hostelId, setHostelId] = useState("");
  const [hostelVal, setHostelVal] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [floorData, setFloorData] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [selectedAttendanceeType, setSelectedAttendanceType] = useState("");
  const [selectedAttendanceeTypeName, setSelectedAttendanceTypeName] =
    useState("");
  const [selectedDate, setSelectedDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedFloorName, setSelectedFloorName] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const params = useParams();

  const getTitle = () => {
    return params?.type
      ? `${upperCase(params.type)} Attendance Marked Report`
      : "Attendance Marked Report";
  };

  const bakcLinkClick = () => {
    let path = params?.category ? "/staff/app/my-att-report" : "/staff/app";
    navigate(path);
  };
  const handleChangeType = (e) => {
    setSelectedAttendanceType(e.target.value);
    const selectedOption = e.target.options[e.target.selectedIndex];
    const customAttributeValue = selectedOption.getAttribute("data-attr");
    const hostelval = selectedOption.getAttribute("data-key");
    setSelectedAttendanceTypeName(customAttributeValue);
    let filteredFloor = floorData.filter((item) => item.hostel_id == hostelval);
    setFloorList(filteredFloor);
    setHostelVal(hostelval);
  };

  const handleReload = () => {
    if (dayOrderDatesRef.current) {
      dayOrderDatesRef.current.reload();
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("staff_id", context.user.id);
    axios.post(ServiceUrl.MOB.GET_HOSTEL_DETAILS, form).then((res) => {
      if (res["data"].status == "1") {
        setHostelId(res["data"].hostel_id);

        let filteredArray = res["data"].data;
        let filteredFloorArray = res["data"].floor;

        setCategoryList(filteredArray);
        setFloorData(filteredFloorArray);
        setFloorList(filteredFloorArray);
        setRoomList(res["data"].rooms);
        setLoader(false);
      }
    });
  };
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const onfinish = (item) => {
    reloadComponent();
  };

  const [reloadKey, setReloadKey] = useState(0);

  const reloadComponent = () => {
    setReloadKey((prevKey) => prevKey + 1); // Change the key to force remount
  };

  return (
    <>
      <Header
        onBack={(e) => bakcLinkClick()}
        title={getTitle()}
        backAction={true}
        rightActions={[]}
      />
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
        className="container"
      >
        <button onClick={toggleVisibility} className="btn btn-primary">
          {isVisible ? "Hide Filter" : "Show Filter"}
        </button>
      </div>
       {isVisible && (
        <div className="container">
          <Form
            name="from"
            id="attendance"
            onFinish={(e) => handleReload(e)}
            footer={
              <Button
                type="submit"
                variant="danger"
                size="lg"
                className="w-100"
              >
                Search
              </Button>
            }
          >
            <Form.Item name="course_type" label="Attendance Date">
              <input
                className="form-control form-control-sm fw-bold"
                type="date"
                size="sm"
                max={momentDate(new Date(), "YYYY-MM-DD")}
                onChange={(e) => setSelectedDate(e.target.value)}
                defaultValue={selectedDate}
              />
            </Form.Item>

            <Form.Item name="attendance_type" label="Attendance Type">
              <select
                className="form-select form-select-sm fw-bold"
                onChange={(e) => {
                  handleChangeType(e);
                }}
                value={selectedAttendanceeType}
              >
                <option value="">Select</option>
                {categoryList.map((item) => {
                  return (
                    <option
                      value={item.id}
                      data-attr={item.attendence_name}
                      data-key={item.hostel_id}
                      selected={
                        selectedAttendanceeType == item.id ? "selected" : ""
                      }
                    >
                      {item.hostel_name} - {item.attendence_name}
                    </option>
                  );
                })}
              </select>
            </Form.Item>
            <Form.Item name="attendance_floor" label="Attendance Floor">
              <select
                className="form-select form-select-sm fw-bold"
                onChange={(e) => {
                  setSelectedFloor(e.target.value);
                  const selectedOption =
                    e.target.options[e.target.selectedIndex];
                  const customAttributeValue =
                    selectedOption.getAttribute("data-attr");
                  setSelectedFloorName(customAttributeValue);
                }}
                value={selectedFloor}
              >
                <option value="">Select</option>
                {floorList.map((item) => {
                  return (
                    <option
                      value={item.id}
                      data-attr={item.floor_name}
                      selected={selectedFloor == item.id ? "selected" : ""}
                    >
                      {item.floor_name}
                    </option>
                  );
                })}
              </select>
            </Form.Item>
          </Form>
        </div>
      )} */}
      {props.attendance_date && props.acyear ? (
        <div className="container py-3">
          <section className="top-space pt-0 pb-0">
            <DayOrderByDates
              {...props}
              category={params.category}
              floor_id={params.floor_id}
            />
          </section>
        </div>
      ) : (
        <div className="page-content-wrapper">
          <div className="container py-3">
            <section className="top-space pt-0 pb-0">
              <DayOrderDates
                ref={dayOrderDatesRef}
                attendanceType={params.category}
                category_id={selectedAttendanceeType}
                attendance_date={selectedDate}
                floor_id={selectedFloor}
              />
            </section>
          </div>
        </div>
      )}
    </>
  );
};
export default MarkedHostelAttendanceReport;
